var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.996 5.462v-.026c0-2.35-1.425-3.736-3.838-3.736h-6.32C2.425 1.7 1 3.085 1 5.436v5.121C1 12.908 2.425 14.3 4.838 14.3h6.323c2.412 0 3.838-1.39 3.838-3.742v-.214h-2.967c-1.382-.002-2.501-1.096-2.5-2.444.003-1.345 1.12-2.434 2.5-2.437h2.964z",
    fill: "#979797",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.318 5.457H8.273a.529.529 0 0 0 .534-.525.53.53 0 0 0-.539-.52h-3.95a.53.53 0 0 0-.533.52.529.529 0 0 0 .533.525zm6.507 2.75c.146.666.73 1.134 1.396 1.122h2.275c.277 0 .502-.23.502-.514V7.044a.51.51 0 0 0-.502-.515h-2.329c-.758.003-1.37.632-1.369 1.407 0 .091.01.182.027.27zm2.073-.278a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5890d52e552c0302efd62e5d5e7fd45c.svg";
export { ForwardRef as ReactComponent };